import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from './core/authentication/auth.service';
import { LocalizationManagerService } from './shared/services/localization-manager.service';
import { NavigationService } from './shared/services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  //instance of this service has to be done when app is started
  constructor(translate: TranslateService, 
    private authService: AuthService, 
    private localizationManagerService: LocalizationManagerService,
    private navigationService: NavigationService) {
     
    localizationManagerService.initializeLocalization();
  }

}
